<template>
    <field-repeater
        v-if="setupLoaded"
        ref="input.user_roles"
        v-model="items"
        :label="labelValue || $t('user_roles')"
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :default-item="template"
        hide-remove-row
        :savable="savable"
        @save="$event => $emit('save', items)"
    >
        <template #row="row">
            <app-form-card
                v-model="items[`${row.index}`]"
                :readonly="row.disabled"
                :deleted="items[`${row.index}`].$deleted"
                class="flex-grow-1"
                :disable-remove-button="items.filter(i => !i.$deleted).length === 1 && required"
                @input:editing="items[`${row.index}`].$editing = $event"
                @input:remove="items[`${row.index}`].$deleted = true"
                @input:undo-remove="items[`${row.index}`].$deleted = false"
            >
                <field-organisation-type
                    :ref="`input.user_roles[${row.index}].organisation_type`"
                    v-model="items[`${row.index}`].organisation_type"
                    :disabled="row.disabled"
                    :required="row.required"
                    :exclude="[
                        ...excludeOrganisationTypes,
                        OrganisationTypeEnum.BROKER,
                        OrganisationTypeEnum.CUSTODIAN,
                        OrganisationTypeEnum.NOMINEE,
                        OrganisationTypeEnum.RECEIVINGAGENT,
                        OrganisationTypeEnum.REGISTRAR
                    ]"
                />
                <edit-selection
                    v-if="items[`${row.index}`].can_change_roles"
                    :ref="`input.user_roles[${row.index}].roles`"
                    v-model="items[`${row.index}`].roles"
                    :disabled="row.disabled"
                    :required="row.required"
                    :label="$t('user_role')"
                    :items="items[`${row.index}`].available_roles"
                    :autocomplete="false"
                    multiple
                    class="mb-7"
                />
                <field-organisation
                    v-if="items[`${row.index}`].can_change_organisation"
                    :ref="`input.user_roles[${row.index}].organisation_id`"
                    :value="items[`${row.index}`].organisation_id"
                    :disabled="row.disabled"
                    :required="row.required"
                    :type="items[`${row.index}`].organisation_type"
                    @input:organisation="$event => updateOrganisation(row.index, $event)"
                    @load="$emit('load')"
                />
                <field-visibility-group
                    v-if="items[`${row.index}`].can_change_visibility_group"
                    :ref="`input.user_roles[${row.index}].visibility_group_id`"
                    v-model="items[`${row.index}`].visibility_group_id"
                    :disabled="row.disabled"
                    :adviser-id="items[`${row.index}`].organisation_id"
                />
            </app-form-card>
        </template>
    </field-repeater>
</template>

<script>
import BaseField from './BaseField';
import UserRole from '@/models/UserRole';
import OrganisationTypeEnum from '@/enums/organisation/type';

export default {
    name: 'UserRoles',
    components: {
        FieldRepeater: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/Repeater'
            ),
        AppFormCard: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppFormCard'
            ),
        FieldOrganisationType: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/OrganisationType'
            ),
        FieldOrganisation: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/Organisation'
            ),
        FieldVisibilityGroup: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/VisibilityGroup'
            )
    },
    extends: BaseField,
    props: {
        savable: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: null
        },
        excludeOrganisationTypes: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        OrganisationTypeEnum,
        items: [],
        template: null
    }),
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value && Array.isArray(value) && value !== this.items) {
                    this.items = value.map(item => (item instanceof UserRole ? item : new UserRole(item)));
                }
            }
        },
        items: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal || []);
            }
        }
    },
    methods: {
        async setup() {
            this.template = new UserRole({
                $editing: true,
                type: this.type
            });
        },
        updateOrganisation(index, org) {
            if (org && !org.type) {
                org.type = this.items[`${index}`].organisation_type;
            }

            this.items[`${index}`].organisation = org;
            this.items[`${index}`].organisation_id = org?.id || null;
            this.items[`${index}`].visibility_group = null;
            this.items[`${index}`].visibility_group_id = null;
        }
    }
};
</script>
